module.exports = __webpack_public_path__ + "img/img-3.d14888fa.jpg";